export const getUrlParameter = (name: string): string => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name) || ''
}

export const getFormDataFromUrl = () => {
  const params = {
    valor: getUrlParameter('valor'),
    nome: getUrlParameter('nome'),
    email: getUrlParameter('email'),
    doc: getUrlParameter('doc'),
    tel: getUrlParameter('tel'),
    cep: getUrlParameter('cep'),
    estado: getUrlParameter('estado'),
    cidade: getUrlParameter('cidade'),
    bairro: getUrlParameter('bairro'),
    endereco: getUrlParameter('endereco'),
    numero: getUrlParameter('numero'),
    complemento: getUrlParameter('complemento'),
    parcelas: getUrlParameter('parcelas'),
    metodo: getUrlParameter('metodo'),
    Id: getUrlParameter('Id'),
    IdReservaCurto: getUrlParameter('IdReservaCurto'),
    IdPagamento: getUrlParameter('IdPagamento'),
  }

  return params
}
